import React, { useEffect, useRef } from 'react'
import maplibregl from 'maplibre-gl'
import 'maplibre-gl/dist/maplibre-gl.css'

interface MapLibrePreviewMapProps {
  latitude: number
  longitude: number
  reportId: string
  location: string
  streetAddress: string
}

export default function MapLibrePreviewMap({
  latitude,
  longitude,
  reportId,
  location,
  streetAddress
}: MapLibrePreviewMapProps) {
  const mapContainer = useRef<HTMLDivElement>(null)
  const map = useRef<maplibregl.Map | null>(null)

  useEffect(() => {
    if (map.current) return // initialize map only once

    map.current = new maplibregl.Map({
      container: mapContainer.current!,
      style: {
        version: 8,
        sources: {
          'osm': {
            type: 'raster',
            tiles: [
              'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
            ],
            tileSize: 256,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          }
        },
        layers: [
          {
            id: 'osm-layer',
            type: 'raster',
            source: 'osm',
            minzoom: 0,
            maxzoom: 20
          }
        ]
      },
      center: [longitude, latitude],
      zoom: 16,
      maxZoom: 20,
      minZoom: 1
    })

    // Add marker
    const marker = new maplibregl.Marker({ color: '#3B82F6' })
      .setLngLat([longitude, latitude])
      .setPopup(new maplibregl.Popup().setHTML(`
        <div class="text-sm">
          <div class="font-medium">Raport ${reportId}</div>
          <div>${location || ''} ${streetAddress || ''}</div>
          <div class="text-xs text-gray-500 mt-1">
            ${latitude.toFixed(6)}, ${longitude.toFixed(6)}
          </div>
        </div>
      `))
      .addTo(map.current)

    return () => {
      if (map.current) {
        map.current.remove()
        map.current = null
      }
    }
  }, [latitude, longitude, reportId, location, streetAddress])

  return (
    <div
      ref={mapContainer}
      className="w-full h-full"
      style={{ position: 'relative' }}
    />
  )
}
